import "../styles/Homepage.css";
import Footer from "./Footer";
import { Link } from "react-router-dom";

export default function Homepage() {
  return (
    <>
      <section className="home-hero">

      <video className="home-hero-video" autoPlay loop muted playsInline>
        <source src="/Assets/video_homepage.mp4" type="video/mp4" />
      </video>

      <div className="home-hero-overlay"></div>

      <div className="home-hero-content">

        <div className="home-hero-row">
          <img src="/Assets/logo_hyve.png" alt="logo" className="home-hero-logo" />

          <div className="home-hero-text">
           
            <p>
              Ici, on ne parle pas de sport.<br />
              On vous apprend à le faire vivre.
            </p>
              <Link to="/inscription" className="home-hero-btn">Nous rejoindre</Link>
          </div>
        </div>

      

      </div>

    </section>

      <section className="home-envie">
        <div className="home-envie-left">
          <h2>L'ENVIE DE SE DÉPASSER</h2>
          <p>
          Le Hyve n'est pas une école de fitness. C'est un studio. Un studio fitness premium basé à Paris 9ᵉ. Bootcamp. Pilates Mat. Reformer. Un espace où chaque détail compte : 
          la musique, l'éclairage, les cues du coach, l'accueil. 
          Un endroit où on ne vient pas juste transpirer. 
          L'Academy est née d'un constat simple : les coachs qu'on voyait sortir des formations n'étaient pas prêts à travailler dans un studio comme le nôtre. Pas parce qu'ils manquaient de passion. 
          Mais parce qu'on ne leur avait pas appris les bonnes choses.
          </p>
          <Link to="/lehyve" className="home-envie-btn">
            NOTRE HISTOIRE
          </Link>
        </div>

        <div className="home-envie-right">
          <img src="/Assets/photo-accueil.png" alt="Equipe Le Hyve" />
        </div>
      </section>

{/* le lien nous emmene vers le milieu de la page alors que je veux que ca nous emmene en haut de la page */}
      <section className="cards-section">
        <div className="cards-row">
          <Link to="/cqpif" className="card">
            <img src="/Assets/cqp3.png" alt="CQP" />
            <h3>CQPIF</h3>
          </Link>

          <Link to="/certification" className="card">
            <img src="/Assets/img2-homepage.png" alt="Formations" />
            <h3>CERTIFICATION</h3>
          </Link>
        </div>

        <Link to="/masterclass" className="card3">
          <img src="/Assets/img3-homepage.jpg" alt="Masterclass" />
          <h3>MASTERCLASS</h3>
        </Link>
      </section>

      <section className="faq-section">
        <div className="faq-background">FAQFAQFAQFAQFAQFAQFAQFAQFAQFAQFAQFAQ</div>

        <div className="faq-box">
          <h3>Comment s'inscrire ?</h3>

          <p>
            Il vous suffit de nous écrire à <strong>contact@lehyve.com</strong> ou via la
            rubrique Contact de notre site. Indiquez-nous la formation qui vous intéresse, et nous
            vous enverrons toutes les infos sur le processus d'inscription (peut inclure un test de
            sélection).
          </p>

          <Link to="/contact" className="faq-btn">
            Nous contacter
          </Link>
        </div>
      </section>

      <Footer backgroundColor="black" />

    </>
  );
}